var exports = {
  "$": "MetadataSidebarContainer__DERwAV",
  "b": "CreateIssueAssigneesSection__74Rrn9",
};

module.exports = exports;
